export default __webpack_public_path__ + "static/media/alprada-eommerce.38abd253.png";